import { render, staticRenderFns } from "./TicketsAssignDialog.vue?vue&type=template&id=6b3cf40f&"
import script from "./TicketsAssignDialog.vue?vue&type=script&lang=js&"
export * from "./TicketsAssignDialog.vue?vue&type=script&lang=js&"
import style0 from "./TicketsAssignDialog.vue?vue&type=style&index=0&id=6b3cf40f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports